import * as Yup from "yup";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputAdornment,
  OutlinedInput,
  Radio,
  RadioGroup,
  TextareaAutosize,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import RoutePartnerHeader from "../pages/Shipping/routePartner/RoutePartnerHeader";
import SidebarContext from "../context/SidebarContext";
// import camera from "../../../assets/svg/camera.svg";
import SimpleBar from "simplebar-react";
import { addDoc, collection } from "firebase/firestore";
import { db } from "../firebaseConfig";
import { useFormik } from "formik";
import { toast } from "react-toastify";

const initialValue = {
  orderNo: 0,
  icon:"",
  title: "",
  icon: "",
  desc: "",
  value: 0,
  valuePremium: 0,
  premiumOfferDesc: "",
  valuePreview: "",
  addOnType: "",
  valueUnit: "",
  isUpcoming: false,
  isSystemSelected: false,
  isDisabled: false,
};

const validationSchema = Yup.object().shape({
  orderNo: Yup.number(),
  icon:Yup.string(),
  title: Yup.string(),
  desc: Yup.string(),
  value: Yup.number(),
  valuePremium: Yup.number(),
  premiumOfferDesc: Yup.string(),
  valuePreview: Yup.string(),
  addOnType: Yup.string(),
  valueUnit: Yup.string(),
  isUpcoming: Yup.boolean(),
  isSystemSelected: Yup.boolean(),
  isDisabled: Yup.boolean(),
});

export default function AddItemAddons() {
  const { open } = useContext(SidebarContext);
  const [initialValues, setInitialValues] = useState(initialValue);
  const [loading, setLoading] = useState(false);

  const addItemAddonsForm = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: async (values) => {
      console.log(values, "values>>>");
      setLoading(true);
      try {
        addDoc(collection(db, "mySuiteAddOns"), {
          ...values,
          isDisabled:values.isDisabled==="true"?true:false,
          isSystemSelected:values.isSystemSelected ==="true"?true:false,
          isUpcoming:values?.isUpcoming==="true"?true:false
        }).then(()=>{
            toast.success('Addons added successfully !')
            addItemAddonsForm.resetForm()
        });
        setLoading(false)
      } catch (err) {
        console.log(err);
      }
    },
  });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "96vh",
        margin: "20px",
        marginRight: "0px",
        width: open === true ? "calc(98vw - 240px)" : "calc(98vw - 80px)",
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "12px",
      }}
    >
      <Box sx={{ borderBottom: "1px solid #E5E5E8" }}>
        <RoutePartnerHeader
          pageTitle={`Add Item Addons`}
          currentRoute={`Add Item Addons`}
          buttonName="Save"
          handleCancle={() => {}}
          handleSave={addItemAddonsForm.handleSubmit}
          loading={loading}
        />
      </Box>
      <SimpleBar
        forceVisible="y"
        autoHide={true}
        style={{
          maxHeight: "82vh",
        }}
        className="custom-scrollbar"
      >
        <Box>
          <Box>
            <Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ marginRight: "2vw" }}>
                  <Typography
                    sx={{ fontWeight: 600, fontSize: "14px", color: "#1C2630" }}
                  >
                    Order No
                  </Typography>
                  <FormControl
                    sx={{
                      m: 1,
                      minHeight: "35px",
                      width: "23vw",
                      marginX: "0px",
                    }}
                    size="small"
                  >
                    <OutlinedInput
                      type="number"
                      id="orderNo"
                      placeholder="Route Partner Name"
                      name="orderNo"
                      value={addItemAddonsForm.values.orderNo}
                      onChange={addItemAddonsForm.handleChange}
                      sx={{
                        marginX: "0px",
                        ".MuiOutlinedInput-notchedOutline": {
                          width: "23vw",
                        },
                      }}
                    />
                  </FormControl>
                  {addItemAddonsForm.touched.orderNo &&
                    addItemAddonsForm.errors.orderNo && (
                      <span className="small text-danger">
                        {addItemAddonsForm.errors.orderNo}
                      </span>
                    )}
                </Box>
              </Box>
            </Box>
            <Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ marginRight: "2vw" }}>
                  <Typography
                    sx={{ fontWeight: 600, fontSize: "14px", color: "#1C2630" }}
                  >
                    Icon
                  </Typography>
                  <FormControl
                    sx={{
                      m: 1,
                      minHeight: "35px",
                      width: "23vw",
                      marginX: "0px",
                    }}
                    size="small"
                  >
                    <OutlinedInput
                      type="string"
                      id="icon"
                      placeholder="Icon URL"
                      name="icon"
                      value={addItemAddonsForm.values.icon}
                      onChange={addItemAddonsForm.handleChange}
                      sx={{
                        marginX: "0px",
                        ".MuiOutlinedInput-notchedOutline": {
                          width: "23vw",
                        },
                      }}
                    />
                  </FormControl>
                  {addItemAddonsForm.touched.icon &&
                    addItemAddonsForm.errors.icon && (
                      <span className="small text-danger">
                        {addItemAddonsForm.errors.icon}
                      </span>
                    )}
                </Box>
              </Box>
            </Box>
            <Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ marginRight: "2vw" }}>
                  <Typography
                    sx={{ fontWeight: 600, fontSize: "14px", color: "#1C2630" }}
                  >
                    Title
                  </Typography>
                  <FormControl
                    sx={{
                      m: 1,
                      minHeight: "35px",
                      width: "23vw",
                      marginX: "0px",
                    }}
                    size="small"
                  >
                    <OutlinedInput
                      type="text"
                      id="title"
                      placeholder="Route Partner Name"
                      name="title"
                      value={addItemAddonsForm.values.title}
                      onChange={addItemAddonsForm.handleChange}
                      sx={{
                        marginX: "0px",
                        ".MuiOutlinedInput-notchedOutline": {
                          width: "23vw",
                        },
                      }}
                    />
                  </FormControl>
                  {addItemAddonsForm.touched.title &&
                    addItemAddonsForm.errors.title && (
                      <span className="small text-danger">
                        {addItemAddonsForm.errors.title}
                      </span>
                    )}
                </Box>
              </Box>
            </Box>
            <Box sx={{ marginTop: "20px" }}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ marginRight: "2vw" }}>
                  <Typography
                    sx={{ fontWeight: 600, fontSize: "14px", color: "#1C2630" }}
                  >
                    desc
                  </Typography>
                  <FormControl
                    sx={{
                      m: 1,
                      minHeight: "35px",
                      width: "23vw",
                      marginX: "0px",
                    }}
                    size="small"
                  >
                    <OutlinedInput
                      type="text"
                      id="desc"
                      placeholder="desc"
                      name="desc"
                      value={addItemAddonsForm.values.desc}
                      onChange={addItemAddonsForm.handleChange}
                      sx={{
                        marginX: "0px",
                        ".MuiOutlinedInput-notchedOutline": {
                          width: "23vw",
                        },
                      }}
                    />
                  </FormControl>
                  {addItemAddonsForm.touched.desc &&
                    addItemAddonsForm.errors.desc && (
                      <span className="small text-danger">
                        {addItemAddonsForm.errors.desc}
                      </span>
                    )}
                </Box>
              </Box>
            </Box>
            <Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ marginRight: "2vw" }}>
                  <Typography
                    sx={{ fontWeight: 600, fontSize: "14px", color: "#1C2630" }}
                  >
                    Value
                  </Typography>
                  <FormControl
                    sx={{
                      m: 1,
                      minHeight: "35px",
                      width: "23vw",
                      marginX: "0px",
                    }}
                    size="small"
                  >
                    <OutlinedInput
                      type="number"
                      id="value"
                      placeholder="Value"
                      name="value"
                      value={addItemAddonsForm.values.value}
                      onChange={addItemAddonsForm.handleChange}
                      sx={{
                        marginX: "0px",
                        ".MuiOutlinedInput-notchedOutline": {
                          width: "23vw",
                        },
                      }}
                    />
                  </FormControl>
                  {addItemAddonsForm.touched.value &&
                    addItemAddonsForm.errors.value && (
                      <span className="small text-danger">
                        {addItemAddonsForm.errors.value}
                      </span>
                    )}
                </Box>
              </Box>
            </Box>
            <Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ marginRight: "2vw" }}>
                  <Typography
                    sx={{ fontWeight: 600, fontSize: "14px", color: "#1C2630" }}
                  >
                    Value Premium 
                  </Typography>
                  <FormControl
                    sx={{
                      m: 1,
                      minHeight: "35px",
                      width: "23vw",
                      marginX: "0px",
                    }}
                    size="small"
                  >
                    <OutlinedInput
                      type="number"
                      id="valuePremium"
                      placeholder="Value Premium"
                      name="valuePremium"
                      value={addItemAddonsForm.values.valuePremium}
                      onChange={addItemAddonsForm.handleChange}
                      sx={{
                        marginX: "0px",
                        ".MuiOutlinedInput-notchedOutline": {
                          width: "23vw",
                        },
                      }}
                    />
                  </FormControl>
                  {addItemAddonsForm.touched.valuePremium &&
                    addItemAddonsForm.errors.valuePremium && (
                      <span className="small text-danger">
                        {addItemAddonsForm.errors.valuePremium}
                      </span>
                    )}
                </Box>
              </Box>
            </Box>
            <Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ marginRight: "2vw" }}>
                  <Typography
                    sx={{ fontWeight: 600, fontSize: "14px", color: "#1C2630" }}
                  >
                    Premium Offer Desc 
                  </Typography>
                  <FormControl
                    sx={{
                      m: 1,
                      minHeight: "35px",
                      width: "23vw",
                      marginX: "0px",
                    }}
                    size="small"
                  >
                    <OutlinedInput
                      type="string"
                      id="premiumOfferDesc"
                      placeholder="Premium Offer Desc"
                      name="premiumOfferDesc"
                      value={addItemAddonsForm.values.premiumOfferDesc}
                      onChange={addItemAddonsForm.handleChange}
                      sx={{
                        marginX: "0px",
                        ".MuiOutlinedInput-notchedOutline": {
                          width: "23vw",
                        },
                      }}
                    />
                  </FormControl>
                  {addItemAddonsForm.touched.premiumOfferDesc   &&
                    addItemAddonsForm.errors.premiumOfferDesc   && (
                      <span className="small text-danger">
                        {addItemAddonsForm.errors.premiumOfferDesc  }
                      </span>
                    )}
                </Box>
              </Box>
            </Box>
            <Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ marginRight: "2vw" }}>
                  <Typography
                    sx={{ fontWeight: 600, fontSize: "14px", color: "#1C2630" }}
                  >
                    Value Preview 
                  </Typography>
                  <FormControl
                    sx={{
                      m: 1,
                      minHeight: "35px",
                      width: "23vw",
                      marginX: "0px",
                    }}
                    size="small"
                  >
                    <OutlinedInput
                      type="string"
                      id="valuePreview"
                      placeholder="Value Preview"
                      name="valuePreview"
                      value={addItemAddonsForm.values.valuePreview}
                      onChange={addItemAddonsForm.handleChange}
                      sx={{
                        marginX: "0px",
                        ".MuiOutlinedInput-notchedOutline": {
                          width: "23vw",
                        },
                      }}
                    />
                  </FormControl>
                  {addItemAddonsForm.touched.valuePreview &&
                    addItemAddonsForm.errors.valuePreview && (
                      <span className="small text-danger">
                        {addItemAddonsForm.errors.valuePreview}
                      </span>
                    )}
                </Box>
              </Box>
            </Box>
            <Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ marginRight: "2vw" }}>
                  <Typography
                    sx={{ fontWeight: 600, fontSize: "14px", color: "#1C2630" }}
                  >
                    Value Type 
                  </Typography>
                  <FormControl
                    sx={{
                      m: 1,
                      minHeight: "35px",
                      width: "23vw",
                      marginX: "0px",
                    }}
                    size="small"
                  >
                    <OutlinedInput
                      type="string"
                      id="addOnType"
                      placeholder="Value Type"
                      name="addOnType"
                      value={addItemAddonsForm.values.addOnType}
                      onChange={addItemAddonsForm.handleChange}
                      sx={{
                        marginX: "0px",
                        ".MuiOutlinedInput-notchedOutline": {
                          width: "23vw",
                        },
                      }}
                    />
                  </FormControl>
                  {addItemAddonsForm.touched.addOnType   &&
                    addItemAddonsForm.errors.addOnType   && (
                      <span className="small text-danger">
                        {addItemAddonsForm.errors.addOnType  }
                      </span>
                    )}
                </Box>
              </Box>
            </Box>
            <Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box sx={{ marginRight: "2vw" }}>
                  <Typography
                    sx={{ fontWeight: 600, fontSize: "14px", color: "#1C2630" }}
                  >
                    Value Unit 
                  </Typography>
                  <FormControl
                    sx={{
                      m: 1,
                      minHeight: "35px",
                      width: "23vw",
                      marginX: "0px",
                    }}
                    size="small"
                  >
                    <OutlinedInput
                      type="string"
                      id="valueUnit"
                      placeholder="Value Unit "
                      name="valueUnit"
                      value={addItemAddonsForm.values.valueUnit}
                      onChange={addItemAddonsForm.handleChange}
                      sx={{
                        marginX: "0px",
                        ".MuiOutlinedInput-notchedOutline": {
                          width: "23vw",
                        },
                      }}
                    />
                  </FormControl>
                  {addItemAddonsForm.touched.valueUnit &&
                    addItemAddonsForm.errors.valueUnit && (
                      <span className="small text-danger">
                        {addItemAddonsForm.errors.valueUnit}
                      </span>
                    )}
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                marginTop: "20px",
              }}
            >
              <Box>
                <Typography
                  sx={{ fontWeight: 600, fontSize: "14px", color: "#1C2630" }}
                >
                  isUpcoming
                </Typography>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  <FormControlLabel
                    value={true}
                    control={
                      <Radio
                        size="small"
                        name="isUpcoming"
                        checked = {addItemAddonsForm.values.isUpcoming === "true"}
                        onChange={addItemAddonsForm.handleChange}
                      />
                    }
                    label="Yes"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio name="isUpcoming" size="small" checked = {addItemAddonsForm.values.isUpcoming === "false"} onChange={addItemAddonsForm.handleChange}/>}
                    label="No"
                  />
                </RadioGroup>
              </Box>
            </Box>
            <Box
              sx={{
                marginTop: "20px",
              }}
            >
              <Box>
                <Typography
                  sx={{ fontWeight: 600, fontSize: "14px", color: "#1C2630" }}
                >
                  isSystemSelected 
                </Typography>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  <FormControlLabel
                    value={true}
                    control={
                        <Radio
                        size="small"
                        name="isSystemSelected"
                        checked = {addItemAddonsForm.values.isSystemSelected === "true"}
                        onChange={addItemAddonsForm.handleChange}
                      />
                    }
                    label="Yes"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio name="isSystemSelected" size="small" checked = {addItemAddonsForm.values.isSystemSelected  === "false"} onChange={addItemAddonsForm.handleChange}/>}
                    label="No"
                  />
                </RadioGroup>
              </Box>
            </Box>
            <Box
              sx={{
                marginTop: "20px",
              }}
            >
              <Box>
                <Typography
                  sx={{ fontWeight: 600, fontSize: "14px", color: "#1C2630" }}
                >
                  isDisabled 
                </Typography>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                >
                  <FormControlLabel
                    value={true}
                    control={
                      <Radio
                        size="small"
                        name="isDisabled"
                        checked = {addItemAddonsForm.values.isDisabled === "true"}
                        onChange={addItemAddonsForm.handleChange}
                      />
                    }
                    label="Yes"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio name="isDisabled" size="small" checked = {addItemAddonsForm.values.isDisabled  === "false"} onChange={addItemAddonsForm.handleChange}/>}
                    label="No"
                  />
                </RadioGroup>
              </Box>
            </Box>
          </Box>
        </Box>
      </SimpleBar>
    </Box>
  );
}
